// Filters

const CollectionFiltersSelectors = {
  dialog: ".collection-filters-dialog",
  dialogFilters: "collection-filters",
  dialogFooter: "footer",
  dialogHeader: "header",
  grids: ".grids",
  pagination: ".pagination",
  productsCount: "[data-products-count]",
}

class CollectionFilters extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;
    this.section = this.closest('section');
    this.productsCount = this.section.querySelector(CollectionFiltersSelectors.productsCount);
    this.grids = this.section.querySelector(CollectionFiltersSelectors.grids);
    this.pagination = this.section.querySelector(CollectionFiltersSelectors.pagination);
    this.dialog = this.section.querySelector(CollectionFiltersSelectors.dialog);
    this.dialogHeader = this.dialog.querySelector(CollectionFiltersSelectors.dialogHeader);
    this.dialogFooter = this.dialog.querySelector(CollectionFiltersSelectors.dialogFooter);

    window.observeStickyness(
      this.section.querySelector('.collection__header'),
      "collection-header"
    );
    
    if (this.dialog.hasAttribute('open')) {
      this.activate();
    } else {
      this.deactivate();
    }

    this.querySelectorAll('.filter__values a').forEach(link => {
      link.addEventListener('click', this.onFilterClick.bind(this));
    })
  }

  activate() {
    this.dialog.show();
  }

  deactivate() {
    this.dialog.close(); 
  }

  toggle() {
    (this.dialog.open) ?
      this.deactivate() :
      this.activate();
  }

  onFilterClick(ev) {
    ev.preventDefault();
    this.fetchRemoteContentForLink(ev.currentTarget.href);
  }

  fetchRemoteContentForLink(link, pushState=true) {
    let url = new URL(link);

    if (pushState) {
      window.history.pushState(
        {
          collectionFilter: true,
          url: url.href,
        }, 
        null, 
        url.href
      );
    }

    url.searchParams.set("section_id", this.sectionId);
    
    fetch(
      url
    )
      .then(response => response.text())
      .then(text => {
        let newSection = new DOMParser().parseFromString(text, 'text/html').querySelector('section');
        let newProductsCount = newSection.querySelector(CollectionFiltersSelectors.productsCount);
        let newGrids = newSection.querySelector(CollectionFiltersSelectors.grids);
        let newPagination = newSection.querySelector(CollectionFiltersSelectors.pagination);
        let newDialog = newSection.querySelector(CollectionFiltersSelectors.dialog);
        let newDialogFilters = newDialog.querySelector(CollectionFiltersSelectors.dialogFilters);
        let newDialogHeader = newDialog.querySelector(CollectionFiltersSelectors.dialogHeader);
        let newDialogFooter = newDialog.querySelector(CollectionFiltersSelectors.dialogFooter);

        newProductsCount.classList.add('highlight--var')
        this.productsCount.replaceWith(newProductsCount);
        this.grids.replaceWith(newGrids);
        this.pagination.replaceWith(newPagination);
        this.dialogHeader.replaceWith(newDialogHeader);
        this.dialogFooter.replaceWith(newDialogFooter);
        this.replaceWith(newDialogFilters);
      });
  }
}

window.addEventListener('popstate', ev => {
  if (ev.state && ev.state.collectionFilter && ev.state.url) {
    document.querySelectorAll(CollectionFiltersSelectors.dialogFilters).forEach(el => {
      el.fetchRemoteContentForLink(ev.state.url, false);
    });
  }
})

customElements.define("collection-filters", CollectionFilters);

// Custom Pagination

class CustomPagination extends HTMLElement {
  constructor() {
    super();

    this.target = document.querySelector(this.dataset.target);
    this.targetSelector = this.dataset.targetSelector;
    this.sectionId = this.dataset.sectionId;

    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(ev) {
    ev.preventDefault();
    let href = ev.target.href || ev.target.closest("[href]").href;
    if (href) this.fetchContent(href);
  }

  fetchContent(url) {
    url = new URL(url);
    url.searchParams.append("section_id", this.sectionId);

    fetch(
      url
    )
      .then(response => response.text())
      .then(text => {
        let html = new DOMParser().parseFromString(text, "text/html");
        let newTarget = html.querySelector(this.dataset.target);
        
        if (this.targetSelector) {
          newTarget.querySelectorAll(this.targetSelector).forEach(el => {
            this.target.append(el);
            el.querySelectorAll("better-image").forEach(img => img.reset());
          })
        } else {
          this.target.replaceWith(newTarget);
          this.target.querySelectorAll("better-image").forEach(img => img.reset());
        }

        

        let newPagination = html.getElementById(this.id);
        this.replaceWith(newPagination);
      })
  }
}

customElements.define("custom-pagination", CustomPagination);